import { createContext } from 'react';

/** True on the chart detail route (dashboard vs details layout in MUI renderers). */
export const ChartDetailsContext = createContext(false);
